import {HvlFormGroup} from '@hvlng/framework-bff/core';
import {AbstractControl} from "@angular/forms";

export class HrHvlFormGroup<T> extends HvlFormGroup<T> {
    private instance: T;

    constructor(annotatedInstance: T) {
        super(annotatedInstance);
        this.instance = annotatedInstance;
    }

    public getClassName(): string {
        return this.instance.constructor.name;
    }

    public getValTypeSafe(key: keyof T): any | null {
        return this.get(key as string).value;
    }

    public setValTypeSafe(key: keyof T, value: any): void {
        this.get(key as string).setValue(value);
    }

    public getTypeSafe(key: keyof T): AbstractControl {
        return this.get(key as string);
    }
}
